module.exports = __webpack_public_path__ + "img/MultiStrikeLightMode.e943fb8b.svg";